<!--
 * @Date: 2023-12-29 11:13:07
 * @Author: jm
 * @LastEditTime: 2024-03-07 15:20:07
 * @LastEditors: jm
 * @FilePath: \miniclub\src\components\HeaderBar.vue
 * @Description: 
-->
<template>
  <div class="bar_wrap" :style="{ bottom: position + '%' }">
    <a
      @click="onChangeTabIndex(index)"
      v-for="(item, index) in list"
      class="bar_item"
      :href="item.path"
    >
      <div class="pic_con" v-if="currIdx == index">
        <img class="pic" :src="item.icon_select" />
      </div>
      <div class="pic_con" v-else>
        <img class="pic" :src="item.icon" alt="" />
      </div>
      <p
        class="text"
        :style="{ color: currIdx == index ? '#FF6464' : '#FFFFFF' }"
      >
        {{ item.text }}
      </p>
    </a>
  </div>
</template>

<script>
import icon1 from "../assets/images/home.png";
import icon2 from "../assets/images/history.png";
import icon3 from "../assets/images/category.png";
import icon4 from "../assets/images/about.png";
import select1 from "../assets/images/home_select.png";
import select2 from "../assets/images/history_select.png";
import select3 from "../assets/images/category_select.png";
import select4 from "../assets/images/about_select.png";
export default {
  name: "HeaderBar",
  props: {
    active: {
      type: Number,
      required: true,
    },
    position: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      currIdx: 0,
      list: [
        {
          icon: icon1,
          icon_select: select1,
          text: "HOME",
          path: "home.html",
        },
        {
          icon: icon2,
          icon_select: select2,
          text: "HISTORY",
          path: "history.html",
        },
        {
          icon: icon3,
          icon_select: select3,
          text: "CATEGORY",
          path: "category.html",
        },
        {
          icon: icon4,
          icon_select: select4,
          text: "ABOUT US",
          path: "about.html",
        },
      ],
    };
  },
  mounted() {
    this.currIdx = this.active;
  },
  methods: {
    onChangeTabIndex(index) {
      this.currIdx = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.bar_wrap {
  padding: 10px 0px;
  background: #303137;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 1080px;
  height: 190px;
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0);
  z-index: 99999999;
  .bar_item {
    width: 280px;
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: aqua;
    position: relative;
    .text {
      margin-top: 20px;
      white-space: nowrap;
      font-size: 30px;
      font-weight: 600;
    }
    .pic_con {
      width: 60px;
      height: 60px;
      .pic {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
